import styled from 'styled-components'

export default styled.div`
  :not(:last-child) {
    margin-bottom: 70px
  }
  .list-container {
    overflow-y: scroll;
    /* CP: removed inertia scrolling as it locks after bouncing. Bug in iOS. */
    /* -webkit-overflow-scrolling: touch; */
    max-height: 65vh;
  }

  .item {
    height: 56px;
    padding: 17px 16px 17px 0;
    border-bottom: 1px solid #c7c7cc;
    margin-left: 16px;
    &.disabled {
      opacity: 0.3;
    }
  }

  .item-container {
    position: relative;
    line-height: 1em;

    .color-swatch {
      position: absolute;
      left: 1px;
      top: -1px;
    }

    .size-label, .shadetext {
      font-family: 'ABChanel PB Regular S', Arial, sans-serif;
      font-size: 12px;
      letter-spacing: -0.4px;
      text-align: left;
    }

    .color-option-label {
      padding-left: 36px;
    }
  }

  .label {
    display: inline-flex;
  }

  .tick {
    width: 16px;
    height: 12.3px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .title-container {
    position: relative;
    height: 44px;
    text-align: center;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title {
    font-family: 'ABChanel PB Regular S', Arial, sans-serif;
    font-size: 16px;
    letter-spacing: -0.03em;
    margin-bottom: 0;
  }

  .close-btn {
    position: absolute;
    margin: auto;
    top: 0;
    right: 16px;
    bottom: 0;
    opacity: 0.4;
  }

  .title-border {
    width: 100%;
    height: 1px;
    background-color: #c7c7cc;
  }

  .item-border {
    width: 95%;
    height: 1px;
    background-color: #c7c7cc;
  }
`



// WEBPACK FOOTER //
// ./src/styles/BottomSheetSelectList.js